import { Stack } from '@mantine/core'
import type { PropertyWithRelations, VisitWithRelations } from '@markku/types'
import { CertificatesCard } from './CertificatesCard'
import { CompletedTasksList } from './CompletedTasksList'
import { PropertySurveyCard } from './PropertySurveyCard'
import { VisitNotesCard } from './VisitNotesCard'
import { VisitPaymentCard } from './VisitPaymentCard'
import { VisitSummaryCard } from './VisitSummaryCard'

interface PastVisitProps {
  visit: VisitWithRelations
  property?: PropertyWithRelations
}

export function PastVisit({ visit, property }: PastVisitProps) {
  const isSurvey = visit.eventType === 'survey'

  return (
    <Stack gap="lg">
      <VisitSummaryCard visit={visit} />
      <VisitPaymentCard visit={visit} />
      <VisitNotesCard visit={visit} />
      {isSurvey && <PropertySurveyCard visit={visit} />}
      <CertificatesCard visitId={visit.id} property={property} />
      <CompletedTasksList visit={visit} />
    </Stack>
  )
}
